module.exports = __webpack_public_path__ + "facebook-image-yoga.2992402226c02a69c0fff81a72c61ed8.jpg";